import { jsx as _jsx } from "react/jsx-runtime";
import { ApolloClient, ApolloProvider, createHttpLink, } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { useMemo } from 'react';
import { getCache } from './useGraphQLProviderConfig';
const getHttpLink = (uri) => createHttpLink({ uri });
const getAuthLink = (configHeaders = {}) => setContext((_, { headers }) => {
    return {
        headers: {
            ...headers,
            ...configHeaders,
        },
    };
});
// separate client per partner to improve data isolation and reduce amount of refetches
const clientPool = new Map();
export function getClient(config, rawPartnerId, ignoreClientPool = false) {
    if (!config.uri)
        return null;
    const partnerId = rawPartnerId ?? '*';
    if (!ignoreClientPool && clientPool.has(partnerId)) {
        return clientPool.get(partnerId);
    }
    const cache = getCache(String(partnerId));
    const client = new ApolloClient({
        link: getAuthLink(config.headers).concat(getHttpLink(config.uri)),
        cache,
        ...config,
    });
    if (!ignoreClientPool) {
        clientPool.set(partnerId, client);
    }
    return client;
}
export const GraphQLProvider = ({ children, config, selectedPartnerId, ignoreClientPool = false, }) => {
    const client = useMemo(() => getClient(config, selectedPartnerId, ignoreClientPool), [selectedPartnerId, config, ignoreClientPool]);
    return client ? (_jsx(ApolloProvider, { client: client, children: children }, selectedPartnerId)) : null;
};
